import { useEffect, useState } from "react";

import { fetchAverageRating } from "@/hooks/api/trustpilot/trustpilot";

import { ReviewDataType } from "../../../types/cover-type.type";

export function useTrustpilotRating(brandDomain: string): ReviewDataType {
  const [reviewData, setReviewData] = useState<ReviewDataType>({
    stars: 0,
    score: 0,
    totalReviews: "",
    link: {
      href: "",
    },
  });

  useEffect(() => {
    Promise.resolve(fetchAverageRating(brandDomain as string))
      .then((res) => {
        setReviewData(res);
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.log(
          "[TrustpilotBlock]: No Trustpilot data found. Skip rendering."
        );
      });
  }, [brandDomain]);

  return reviewData;
}
